import React, { memo, useCallback, useState } from 'react';
import { format, parseISO } from 'date-fns';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { CardView } from 'design-system/CardView';
import BuySellHold from 'design-system/BuySellHoldView';
import BuySellHoldViewCircularProgress from 'design-system/BuySellHoldViewCircularProgress';
import { formatPlural } from 'utils/formatting';
import PastRatings from './PastRatings';
const AnalystDetailsCard = ({ analystRatingsDetails }) => {
    const [selectedDateObj, setSelectedDateObj] = useState(analystRatingsDetails[0]);
    const ratingsTotal = selectedDateObj.data?.ratingsTotal || 0;
    const handlePress = useCallback((date) => {
        setSelectedDateObj(date);
    }, []);
    return (<CardView noMarginBottom withPadding>
      <Text Text-20>{format(parseISO(selectedDateObj.date), 'MMMMMM yyyy')}</Text>
      <Text TextThin-14 Secondary>
        {ratingsTotal} {formatPlural('analyst', 'analysts', ratingsTotal)}
      </Text>
      <Spacer h={16}/>
      <View style={styles.circularProgressContainer}>
        <BuySellHoldViewCircularProgress large buyPercent={selectedDateObj.data?.buyPercent} sellPercent={selectedDateObj.data?.sellPercent} holdPercent={selectedDateObj.data?.holdPercent}/>
      </View>
      <Spacer h={16}/>
      <BuySellHold variable buyPercent={selectedDateObj.data?.buyPercent} sellPercent={selectedDateObj.data?.sellPercent} holdPercent={selectedDateObj.data?.holdPercent}/>
      <Spacer h={24}/>
      <PastRatings handlePress={handlePress} selectedDate={selectedDateObj.date} analystRatingsDetails={analystRatingsDetails}/>
    </CardView>);
};
const styles = StyleSheet.create({
    circularProgressContainer: {
        alignItems: 'center',
    },
});
export default memo(AnalystDetailsCard);
